(($) => {
    $.loadDimProdInfo = function (options) {
        var o = $.extend({
            itemId: 0,
            imgWidth: 120,
            imgMod: 'crop=none',
            dim1Val: '',
            dim2Val: '',
            dim3Val: '',
            prodNo: '',
            stock: '',
            price: '',
            orig: '',
            disc: '',
            image: '',
            error: '',
            buyRow: '',
            origRow: '',
            discRow: '',
            priceFrom: '',
            loadImg: window.R + 'Startup/Pics/wait3.gif',
            //usePrice: 1, <-- PriceField SHOULD NOT BE HARDCODED (UMWC-319)
            loadDimProdImg: true,
            additionalReqParams: {},
            dimImageShouldDifferFromMain: false,
            mainProdImageId: 0,
            errHandler: null,
            okHandler: null,
            priceVisible: true
        }, options || {});

        var loadImg = '<img alt="loading..." src="' + o.loadImg + '" />',
            prodNo = $(o.prodNo),
            stock = $(o.stock),
            price = $(o.price),
            orig = $(o.orig),
            disc = $(o.disc),
            image = $(o.image),
            error = $(o.error),
            buyRow = $(o.buyRow),
            origRow = $(o.origRow),
            discRow = $(o.discRow);

        //Set loading image
        prodNo.html(loadImg);

        var reqParams = $.extend(o.additionalReqParams, {
            a: "GetDimDetails",
            ItemID: o.itemId,
            Dim1: o.dim1Val ? o.dim1Val : "0",
            Dim2: o.dim2Val ? o.dim2Val : "0",
            Dim3: o.dim3Val ? o.dim3Val : "0",
            ImageWidth: o.imgWidth,
            ImgMod: o.imgMod,
            usePrice: o.usePrice,
            priceVisible: o.priceVisible
        });

        //Fetch dim details
        $.publicFetch({
            handler: "ProductData",
            data: reqParams,
            success: function (d) {
                //Allow buy
                buyRow.css("display", d.AllowBuy === true ? "" : "none");
                //Product number
                prodNo.text(d.ProdNo);
                //Stock text
                stock.text(d.StockText);
                stock.css("color", d.StockColor);
                //Price
                var $priceText = price.find('.notranslate, .PriceValue');
                if ($priceText.length > 0) {
                    $priceText.html(d.Price);
                } else {
                    // Try to keep VAT text if found
                    price.contents().filter(function () { return this.className != 'PriceVatTxt'; }).remove();
                    price.prepend(document.createTextNode(d.Price + ' '));
                }
                price.find('.notranslate.PriceValue.ExclVat').html(d.PriceExclVat);
                price.find('.notranslate.PriceValue.InclVat').html(d.PriceInclVat);

                if (d.HasDiscount) {
                    origRow.show();
                    discRow.show();
                    //Original price
                    var $origPriceText = orig.find('.notranslate, .OriginalPriceValue');
                    if ($origPriceText.length > 0) {
                        $origPriceText.text(d.OriginalPrice);
                    } else {
                        // Try to keep VAT text if found
                        orig.contents().filter(function () { return this.className != 'PriceVatTxt'; }).remove();
                        orig.prepend(document.createTextNode(d.OriginalPrice + ' '));
                    }
                    //Discount price
                    var $discountText = disc.find('.notranslate, .DiscountValue');
                    if ($discountText.length > 0) {
                        $discountText.text(d.Discount);
                    } else {
                        // Try to keep VAT text if found
                        disc.contents().filter(function () { return this.className != 'PriceVatTxt'; }).remove();
                        disc.prepend(document.createTextNode(d.Discount + ' '));
                    }
                } else {
                    origRow.hide();
                    discRow.hide();
                }
                //Image
                if (d.ImageURL.length > 0 && o.loadDimProdImg && !(o.dimImageShouldDifferFromMain && d.ImageID == o.mainProdImageId)) {
                    //Set image url
                    image.attr("src", d.ImageURL);
                    if (d.ImageMaxWidth) {
                        image.css('max-width', d.ImageMaxWidth + 'px');
                    }
                    // Set link to image src
                    if (d.ImageLBURL) {
                        image.closest('a.ImageLink').attr('href', d.ImageLBURL).attr('title', d.ImageText ? d.ImageText : d.ProdNo);
                    }
                }
                // Replacement product
                if (d.ReplacementProductInfo) {
                    if (o.context) {
                        o.context.find('.ReplacementProductRow').empty().html(d.ReplacementProductInfo).show();
                    }

                    window.PubSub.publish('notification.warning', d.ReplacementProductInfo);
                } else {
                    if (o.context) {
                        o.context.find('.ReplacementProductRow').empty().hide();
                    }
                }

                if (o.okHandler && $.isFunction(o.okHandler)) {
                    o.okHandler.call(this, d);
                }

                if (typeof (window.PubSub) !== 'undefined') {
                    window.PubSub.publish('product.dimproduct.update', d);
                }
            },
            error: function (err) {
                if (error.hasClass('ErrMsg')) { error.text(err.Message); }
                else {
                    if (error.find('.ErrMsg').length > 0) { error.find('.ErrMsg').text(err.Message); }
                    else { error.append('<span class="ErrMsg">' + err.Message + '</span>'); }
                }

                prodNo.add(stock).add(price).add(orig).add(disc).html("");
                if (o.errHandler && $.isFunction(o.errHandler)) {
                    o.errHandler.call(this, err);
                }
            }
        });
    };
})(jQuery);